export default "__VITE_ASSET__BHE_3Md7__"